import { render, staticRenderFns } from "./orderItem.vue?vue&type=template&id=4fc0ad25&scoped=true"
import script from "./orderItem.vue?vue&type=script&lang=js"
export * from "./orderItem.vue?vue&type=script&lang=js"
import style0 from "./orderItem.vue?vue&type=style&index=0&id=4fc0ad25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0ad25",
  null
  
)

export default component.exports